import TextField from '@material-ui/core/TextField';
import {withStyles} from '@material-ui/core/styles/index';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

require('../../../bootstrap');

import React, {PureComponent} from 'react';
import {loginWithCredentials, loginWithToken} from "../../api";
import Loader from "../Simple/Loader";

const styles = theme => ({
    card: {
        margin: theme.spacing(1),
        maxWidth: 400,
        padding: theme.spacing(1),
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
    },
    menu: {
        width: 200,
    },
    button: {
        margin: theme.spacing(1),
    },
    imageWrapper: {
        textAlign: 'center',
        padding: theme.spacing(6),
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    image: {
        maxWidth: '100%',
    },
    loadingSpinner: {
        color: theme.palette.primary[500],
        marginRight: theme.spacing(1),
    },
    message: {
        color: 'red',
        marginBottom: -20,
    },
    description: {
        marginBottom: theme.spacing(2),
    }
});

class AuthPinCode extends PureComponent {

    render() {
        const {classes, email, handleChange, postSendAuthPinCode, authPinCodeErrorMessage} = this.props

        return (
            <>
                <CardContent>
                    <Typography gutterBottom variant="body1" align="center" className={classes.description}>
                        Lähetimme koodin puhelimeesi
                    </Typography>
                    <TextField
                        id="outlined-name"
                        label="Koodi"
                        className={classes.textField}
                        value={email}
                        onChange={handleChange('pincode')}
                        margin="normal"
                        variant="outlined"
                    />
                    {authPinCodeErrorMessage && <Typography gutterBottom variant="body1" align="center" className={classes.message}>
                        {authPinCodeErrorMessage}
                    </Typography>}
                </CardContent>
                <CardActions>
                    <Grid
                        justify="space-between"
                        container
                        spacing={1}
                    >
                        <Grid item>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" className={classes.button}
                                    onClick={postSendAuthPinCode}>
                                Kirjaudu
                            </Button>
                        </Grid>
                    </Grid>
                </CardActions>
            </>
        )
    };
}

export default withStyles(styles)(AuthPinCode);
